import React from 'react';
import PropTypes from 'prop-types';
import useForm from '@afosto/utils-react/validation/useForm';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Form from '@afosto/app-components-react/Form';
import TextField from '@afosto/app-components-react/TextField';
import validationSchema from './validations';
import translations from './translations';

const CalculationEditItemForm = ({ onCancel, onSubmit, item }) => {
  const intl = useIntl();
  const { quantity } = item ?? {};
  const form = useForm({
    validationSchema,
    defaultValues: {
      reference: item?.reference ?? '',
      maxQuantity: quantity,
      quantity: quantity ?? 1,
    },
    onSubmit,
    onCancel,
  });

  return (
    <Form form={form}>
      <TextField
        name="quantity"
        label={intl.formatMessage(translations.fields.quantity.label)}
        type="number"
        inputProps={
          quantity && quantity < 0 ? { min: quantity, max: 0 } : { min: 0, max: quantity }
        }
      />
    </Form>
  );
};

CalculationEditItemForm.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  item: PropTypes.object,
};

CalculationEditItemForm.defaultProps = {
  onCancel: undefined,
  onSubmit: undefined,
  item: {},
};

export default CalculationEditItemForm;
